import { render, staticRenderFns } from "./CreatorItem.vue?vue&type=template&id=f674e040&scoped=true&"
import script from "./CreatorItem.vue?vue&type=script&lang=js&"
export * from "./CreatorItem.vue?vue&type=script&lang=js&"
import style0 from "./CreatorItem.vue?vue&type=style&index=0&id=f674e040&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f674e040",
  null
  
)

export default component.exports